import React, { useEffect } from "react"
import { useRoutes } from "react-router-dom"

import { Layout } from "layouts/Layout"
import { allRoutes } from "routes/config"
import { hasAnyRequiredGroup } from "routes/utils"
import { fetchAuthSession, fetchUserAttributes } from "aws-amplify/auth"
import {
  setAuthenticationUserAttributes,
  setAuthenticationUserGroups
} from "lib/store/services/auth/slice"
import { useDispatch, useSelector } from "react-redux"
import { selectUserGroups } from "lib/store/services/auth/selectors"
import { useConfig } from "./configuration/useConfig"
import { Common } from "lib/types"
import { DynamicConfig } from "./configuration/config"

const filterRoutesByGroups = (
  routes: Common.Views,
  userGroups: string[],
  config: DynamicConfig
): Common.Views => {
  return routes
    .filter((route) => {
      if (route.configKey && !config[route.configKey]) {
        return false
      }
      return hasAnyRequiredGroup(userGroups, route.requiredGroups)
    })
    .map((route) => {
      if (route.children && route.children.length > 0) {
        return {
          ...route,
          children: filterRoutesByGroups(route.children, userGroups, config)
        }
      }
      return route
    })
}

export default function SecureRoutes() {
  const dispatch = useDispatch()
  const userGroups = useSelector(selectUserGroups) || []
  const config = useConfig().config

  useEffect(() => {
    fetchAuthSession &&
      fetchAuthSession().then((res) =>
        dispatch(
          setAuthenticationUserGroups({
            userGroups: res.tokens?.accessToken.payload["cognito:groups"]
          })
        )
      )
    fetchUserAttributes &&
      fetchUserAttributes().then((res) =>
        dispatch(setAuthenticationUserAttributes({ userAttributes: res }))
      )
  }, [])

  const accessibleRoutes = filterRoutesByGroups(allRoutes, userGroups, config)

  return useRoutes([
    {
      path: "/",
      element: <Layout />,
      children: accessibleRoutes
    }
  ])
}
